import React from 'react';




const Regulations = () => {
  return (
    <>
    <div id="rec477718616" class="r t-rec t-rec_pt_120 t-rec_pb_60"
    style={{ backgroundColor: '##d9d2d2', paddingTop: '120px', paddingBottom: '60px' }}
    data-record-type="60"
    data-bg-color="#d9d2d2"> 
    <div class="t050 flex">
        <div class="t-container t-align_left">
            <div class="t-col t-col_8 t-prefix_2">
                <div class="t050__uptitle t-uptitle t-uptitle_sm" field="subtitle">МЕЖДУНАРОДНАЯ ПРЕМИЯ «ГЛОБАЛЬНЫЙ ПРОРЫВ»</div>
                <div class="t050__title t-title t-title_xxl" field="title">Положение о Международной Премии «Глобальный Прорыв»</div>
            </div>
        </div>
    </div>
</div>
        <div id="rec477720443" class="r t-rec t-rec_pt_0 t-rec_pb_0"
        style={{ backgroundColor: '##d9d2d2', paddingTop: '0px', paddingBottom: '0px' }} data-record-type="128"
        data-bg-color="#d9d2d2"> 
        <div class="t120 flex">
            <div class="t-container t-align_left">
                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">1. Общие положения</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>1.1. </strong>
                  Международная премия «Глобальный Прорыв» (далее — Премия) является ежегодной престижной наградой для предпринимателей и профессионалов, добившихся значительных успехов в бизнесе, внедривших инновации и способствующих устойчивому развитию в различных отраслях экономики.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>1.2. </strong>
                  Организатором Премии является общероссийская общественная организация «Деловая Россия», которая ставит целью выявление и поощрение лидеров, чьи проекты и инициативы способствуют экономическому росту и укреплению международного сотрудничества.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>1.3. </strong>
                  Премия включает номинации, направленные на различные сферы бизнеса и социальные инициативы, охватывая как национальные, так и международные достижения.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>1.4. </strong>
                  Прием заявок на участие в Премии осуществляется с 1 по 30 сентября каждого года. Церемония награждения проводится ежегодно 5 октября.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">2. Цели и задачи Премии</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>2.1. </strong>
                  Поощрение предпринимателей и компаний, внедривших прорывные идеи и технологии, способствующих росту отраслей и улучшению условий жизни.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>2.2. </strong>
                  Поддержка бизнесменов, которые продвигают экологичность, социальную ответственность и международное сотрудничество.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>2.3. </strong>
                  Популяризация высоких стандартов ведения бизнеса и инновационных решений, обеспечивающих устойчивое развитие.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">3. Номинации Премии</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.1. Международные достижения </strong>
                  Награда для предпринимателей, чьи компании успешно реализовали инициативы на международных рынках, укрепив позиции своей отрасли за рубежом.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.2. Финансы и инвестиции </strong>
                  Номинация для бизнесменов, добившихся выдающихся результатов в финансовом секторе, способствующих устойчивому развитию и инновациям в отрасли.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.3. Строительство и девелопмент </strong>
                  Присуждается предпринимателям за успешные проекты в строительстве, направленные на развитие инфраструктуры и улучшение городской среды.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.4. Ритейл и торговля </strong>
                  Для бизнесменов, достигших значительных успехов в торговле, внедривших передовые подходы и улучшивших клиентский сервис.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.5. Туризм и гостеприимство </strong>
                  Награда для предпринимателей в сфере туризма, гостиничного и ресторанного бизнеса, способствующих росту индустрии и повышению качества сервиса.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.6. Маркетинг и коммуникации </strong> 
                   Для бизнесменов, реализующих проекты в сфере маркетинга, бренд-стратегий и маркетинговых технологий, которые способствуют повышению эффективности продвижения, улучшению взаимодействия с аудиторией и росту коммерческих результатов.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.7. Транспортные инженерные технологии </strong>
                  Для инженеров и предпринимателей, добившихся выдающихся результатов в разработке инновационных транспортных технологий.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.8. Инновации и технологии </strong>
                  Присуждается за проекты, внедрившие передовые технологии, повысившие конкурентоспособность и эффективность отрасли.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.9. Ресторанный бизнес </strong>
                  Номинация для проектов и предпринимательских инициатив в сфере ресторанного бизнеса, направленных на развитие современных гастрономических форматов, повышение качества сервиса, внедрение эффективных управленческих решений и укрепление конкурентоспособности ресторанных проектов.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.10. Спорт и активный образ жизни </strong>
                  Награда для бизнесменов, поддерживающих спортивные проекты и способствующих популяризации здорового образа жизни.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.11. Психология и личностное развитие </strong>
                  Номинация для предпринимателей, внедривших проекты, способствующие личностному росту и поддержке психического здоровья.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>3.12. Мода и стиль </strong>
                  Присуждается за проекты, которые формируют тренды, внедряют инновационные технологии и устойчивые практики, развивая индустрию моды и стиля.
                  </div> 
                </div>                

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">4. Критерии оценки</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>4.1. </strong>
                  Оценка по номинациям проводится на основе следующих критериев:
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md ">
                  — Международные достижения: масштаб охвата, вклад в отрасль, финансовая стабильность, партнерства и инновационные решения.
                  <br />
                  — Финансы и инвестиции: устойчивый рост, инновации, вклад в развитие отрасли, социальная ответственность и операционная эффективность.
                  <br />
                  — Строительство и девелопмент: качество проектов, экономическое влияние, экологичность, социальная значимость и управление проектами.
                  <br />
                  — Ритейл и торговля: инновации в сервисе, качество продукции, экономическая эффективность, клиентоориентированность и вклад в развитие.
                  <br />
                  — Туризм и гостеприимство: качество сервиса, развитие инфраструктуры, инновации, вклад в культуру и экологичность.
                  <br />
                  — Маркетинг и коммуникации: стратегическая эффективность маркетинговых решений, инновационность подходов и технологий, влияние на развитие отрасли маркетинга, социальная и этическая ответственность в коммуникациях, а также измеримая коммерческая эффективность реализованных проектов.
                  <br />
                  — Транспортные инженерные технологии: Для инженеров и предпринимателей, добившихся выдающихся результатов в разработке инновационных транспортных технологий.
                  <br />
                  — Инновации и технологии: уникальность решений, экономическая эффективность, масштабируемость, вклад в отрасль, социальная ответственность.
                  <br />
                  — Ресторанный бизнес: качество концепции и клиентского опыта, операционная эффективность, инновации в управлении и сервисе, масштабируемость бизнес-модели, влияние на отрасль и экономическая устойчивость.
                  <br />
                  — Спорт и активный образ жизни: популяризация ЗОЖ, инновации в услугах, социальное влияние, экономическое воздействие, устойчивость.
                  <br />
                  — Психология и личностное развитие: влияние на благополучие, инновации методик, доступность, социальная значимость и долгосрочные результаты.

                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">5. Порядок участия</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>5.1. </strong>
                  Участники подают заявку на участие в Премии в сроки, указанные в пункте 1.4. К заявке прилагаются документы, подтверждающие достижения по выбранной номинации.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>5.2. </strong>
                  Состав жюри рассматривают заявки и проводит оценку в соответствии с критериями, изложенными в разделе 4.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>5.3. </strong>
                  Победители в каждой номинации утверждаются решением составом экспертного жюри и объявляются на церемонии награждения 5 октября.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">6. Жюри</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>6.1. </strong>
                  Состав Жюри состоит из авторитетных специалистов, представляющих различные отрасли экономики. Жюри несут ответственность за объективность и беспристрастность отбора лауреатов.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>6.2. </strong>
                  Члены жюри оценивают достижения номинантов на основании представленных материалов и обсуждений, следуя утвержденным критериям.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">7. Награждение</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>7.1. </strong>
                  Победители Премии получают почетные дипломы и право использования знака Премии «Глобальный Прорыв» в своей профессиональной деятельности.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>7.2. </strong>
                  Награждение сопровождается освещением в ведущих деловых СМИ, что способствует популяризации достижений лауреатов и их проектов.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">8. Заключительные положения</div>
                </div>

                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md "><strong>8.1. </strong>
                  Настоящее Положение вступает в силу с момента его утверждения и действует до следующей церемонии награждения.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2 pb-150"> 
                  <div field="text" class="t-text t-text_md "><strong>8.2. </strong>
                  Организатор оставляет за собой право вносить изменения в Положение по мере необходимости для улучшения качества проведения Премии.
                  </div> 
                </div>

            </div>
        </div>
    </div>
    </>
  
  );
};

export default Regulations;
